<dx-popup id="error-notification" [height]="'auto'" *ngIf="notification && showPopup" [width]="600" [showTitle]="true"
    [title]="title" [dragEnabled]="false" [closeOnOutsideClick]="false" [visible]="notification && showPopup"
    (onShowing)="onPopupShowing($event)">
    <div id="error-notification-msg" style="height: auto;" *dxTemplate="let data of 'content'">
        <p class="message" *ngIf="notification.message">
            {{ notification.message }}
        </p>
        <p class="message" *ngIf="!notification.message">
            We were unable to process your request due to technical difficulties.
        </p>
        <div *ngIf="notification.technicalDetails">
            <div *ngIf="!showTechDetails">
                For more details click here <dx-button icon="plus" (onClick)="onbtnClick()"></dx-button>
            </div>
            <div *ngIf="showTechDetails" class="card">
                <div class="card-body">
                    <div>
                        <p>
                            <b>Status Code: </b><span id="tech-details">{{notification.technicalDetails.error.Status}}</span>
                        </p>
                        <p>
                            <b>Error Message: </b><span id="tech-details">{{notification.technicalDetails.error.Title}}</span>
                        </p>
                        <p>
                            <b>Trace Id: </b><span id="tech-details">{{notification.technicalDetails.error.TraceId}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <dx-accordion *ngIf="errorDataSource && errorDataSource.length > 0" #accordion [dataSource]="errorDataSource"
            [collapsible]="true" [multiple]="false" [animationDuration]="300" [selectedIndex]="-1">
            <div *dxTemplate="let error of 'title'">
                <span>Technical Details</span>
            </div>
            <div *dxTemplate="let error of 'item'">
                <div>
                    <p>
                        <b>Status Code: </b><span id="tech-details">{{error.TechnicalDetails.status}}</span>
                    </p>
                    <p>
                        <b>Error Message: </b><span id="tech-details">{{error.TechnicalDetails.title}}</span>
                    </p>
                    <p>
                        <b>Trace Id: </b><span id="tech-details">{{error.TechnicalDetails.traceId}}</span>
                    </p>
                </div>
            </div>
        </dx-accordion> -->
        <div class="popupactions">
            <dx-button class="ap-green-btn" text="Okay" (onClick)="onPopUpClosing($event)">
            </dx-button>
        </div>
    </div>
</dx-popup>

<dx-toast *ngIf="toaster && toaster.isToastVisible" message="{{toaster.toastMessage}}" position="top"
    [(displayTime)]="toaster.displayTime" [(type)]="toaster.toastType" width="500px"
    [(visible)]="toaster && toaster.isToastVisible">
</dx-toast>

<dx-popup id="SessionExpireNotification" [width]="370" [height]="150" title="Session Expired (401)" [showTitle]="true"
    [dragEnabled]="false" [closeOnOutsideClick]="false" [visible]="showSessionExpireNotificationPopup">
    <div *dxTemplate="let data of 'content'">
        <p class="message">
            Your session has expired.  Please click the refresh button to continue.
        </p>

        <div class="popupactions">
            <dx-button class="ap-green-btn" text="Refresh" (onClick)="refreshWindow($event)">
            </dx-button>
        </div>
    </div>
</dx-popup>